import { render, staticRenderFns } from "./success-action-button.vue?vue&type=template&id=58dec796&scoped=true&lang=pug&"
import script from "./success-action-button.vue?vue&type=script&lang=js&"
export * from "./success-action-button.vue?vue&type=script&lang=js&"
import style0 from "./success-action-button.vue?vue&type=style&index=0&id=58dec796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dec796",
  null
  
)

export default component.exports